export const upadatePasswordData={
    userId: "",
    oldPassword: "",
    newPassword: "",
    confirmPassword: ""
  }